import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";

const TVARate = ({
    total = null,
    currency = null,
    rate = null,
    color = null,
}) => {
    const format_rate = rate === -1 ? "Autre ou multi" : rate + "%";
    return (
        <SCard $color={color}>
            <SCardTotal content={total + " " + currency} />
            <SCardRate content={format_rate} />
        </SCard>
    );
};

export default TVARate;

const SCardRate = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-1424242,
        #424242
    );

    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px; /* 120% */
`;

const SCardTotal = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );

    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 16px; /* 133.333% */
`;

const SCard = styled(Flex)`
    display: flex;
    padding-left: 6px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-left: 2px solid ${({ $color }) => $color || "#9299f7"};
`;
